import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import store from "./services/redux/store";
import {Provider} from "react-redux";
import './i18n/config';
//import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store} >
        <App />
    </Provider>
);

//serviceWorker.register();
